import { useDependency } from 'ditox-react';
import { Refresh } from 'iconsax-react';
import { useObservableGetState } from 'observable-hooks';
import { filter, map } from 'rxjs';
import SuccessIndicator from '@/components/settings/debug/success-indicator';
import { WEB_SOCKET_MANAGER_TOKEN } from '@/container';
import { IS_PROD } from '@/utils/constants';
import cn from '@/utils/merge-class-names';

type Props = {
  hideOnProd?: boolean;
  className?: string;
};

export function WebSocketStateIndicator({ hideOnProd = true, className }: Props) {
  const webSocketManager = useDependency(WEB_SOCKET_MANAGER_TOKEN);
  const state = useObservableGetState(webSocketManager.state$, 'open');
  const heartbeat = useObservableGetState<number>(
    webSocketManager.heartbeat$.pipe(
      map((d) => {
        const lastItem = d.at(-1);
        return lastItem?.[1] ? Math.abs(lastItem[0] - lastItem[1]) : 0;
      }),
      filter((d) => d > 0),
    ),
    0,
  );

  if (state === 'connecting') {
    return <span className={cn('loading loading-ring loading-sm m-2 text-base-content/50 !size-4', className)} />;
  }

  if (state && ['ended', 'closed'].includes(state)) {
    return (
      <button
        type='button'
        className={cn('btn btn-circle btn-ghost btn-sm', className)}
        onClick={() => webSocketManager.reconnect()}>
        <Refresh className='size-4' />
      </button>
    );
  }

  return !(IS_PROD && hideOnProd) ? (
    <div className='inline-flex rounded border-primary text-neutral-400 items-center gap-0.5'>
      <span className='text-xs font-mono'>{heartbeat || '-'}ms</span>
      <SuccessIndicator
        success
        className={cn('desktop:size-full size-6 aspect-square flex flex-center', className)}
      />
    </div>
  ) : null;
}
